import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-ResponseRateLimiting',
    templateUrl: './ResponseRateLimiting.component.html'
})
export class ResponseRateLimitingComponent implements OnInit {

    consumerID: string;
    headerName: string;
    faultTolerant: boolean;
    redisHost: string;
    redisPort: number;
    redisPassword: string;
    redisTimeout: number;
    redisDatabase: number;
    blockOnFirstViolation: boolean;
    hideClientHeaders: boolean;
    policy = 'locale';
    LimitBy = 'Consumer';


    constructor() { }
    slider() {
        this.faultTolerant = !this.faultTolerant;
    }
    slider1() {
        this.blockOnFirstViolation = !this.blockOnFirstViolation;
    }
    slider2() {
        this.hideClientHeaders = !this.hideClientHeaders;
    }

    ResponseRateLimiting() {
    }

    ngOnInit() {
    }

}
